import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { constants } from '@wsb/guac-widget-core';
import Carousel from '@wsb/guac-widget-shared/lib/components/Carousel';
import SlideshowHero from '../../Slideshow/SlideshowHero';
import SlideshowHeroControl from '../../Slideshow/SlideshowHeroControl';
import { populateHeroContent } from '../../Slideshow/utils';
import dataAids from '../../constants/dataAids';

const TEXT_FADE_DELAY = 800;
const MAX_SLIDES = 6;

const {
  renderModes: { PUBLISH }
} = constants;

export default class HeroCarousel extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      currentSlide: 0,
      showText: false
    };
    this.wrapperRef = React.createRef();
    this.slideRefs = [];
    for (var i = 0; i < MAX_SLIDES; i++) {
      this.slideRefs.push(React.createRef());
    }
  }

  afterChange = currentSlide => {
    const { renderMode, slideshow } = this.props;
    if (renderMode === PUBLISH) {
      populateHeroContent(slideshow, currentSlide);
    }
    this.setState({ currentSlide, showText: false }, () => {
      setTimeout(() => {
        this.setState({ showText: true });
      }, TEXT_FADE_DELAY);
    });
  };

  updateHeight() {
    let max = 0;
    for (var i = 0; i < this.slideRefs.length; i++) {
      const current = this.slideRefs[i].current;
      if (current) {
        max = Math.max(max, current.offsetHeight);
      }
    }
    this.wrapperRef.current.style.height = `${max}px`;
  }

  componentDidMount() {
    this.afterChange(0);
    this.updateHeight();
  }

  componentDidUpdate() {
    this.updateHeight();
  }

  render() {
    const { slideshow, renderMode } = this.props;
    const { currentSlide, showText } = this.state;
    const { slides, alignmentOption, themeConfig, heroIdPrefix } = slideshow;
    const { slideshowId, heroTransition = 'fade' } = themeConfig;

    let foundH1 = false;
    const heroSlides = slides.map((slide, index) => {
      const slideData = slide || {};
      const dataAid = `${dataAids.HEADER_HERO_SLIDE}_${index}`;
      let forceH1 = false;
      if (!foundH1 && slideData.tagline) {
        forceH1 = true;
        foundH1 = true;
      }
      return (
        <div key={ index } ref={ this.slideRefs[index] } data-aid={ dataAid }>
          <SlideshowHero
            slide={ slideData }
            index={ index }
            forceH1={ forceH1 }
            alignmentOption={ alignmentOption }
            heroIdPrefix={ heroIdPrefix }
            themeConfig={ themeConfig }
            renderMode={ renderMode }
            currentSlide={ currentSlide }
            showText={ showText }
            fixedPosition={ false }
          />
        </div>
      );
    });

    const carouselProps = {
      style: {
        container: { height: '100%' },
        containerInner: { height: '100%' },
        track: { height: '100%' }
      },
      viewportWidth: '100%',
      viewportHeight: '100%',
      height: '100%',
      slideWidth: '100%',
      slideHeight: '100%',
      autoplay: false,
      autoplaySpeed: 7000,
      transition: heroTransition,
      transitionDuration: 1000,
      infinite: true,
      lazyLoad: false,
      dots: false,
      arrows: false,
      draggable: true,
      pauseOnHover: false,
      afterChange: this.afterChange,
      controls: [{ component: SlideshowHeroControl, props: { slideshowId } }]
    };

    return (
      <div ref={ this.wrapperRef }>
        <Carousel { ...carouselProps }>{ heroSlides }</Carousel>
      </div>
    );
  }
}

HeroCarousel.propTypes = {
  slideshow: PropTypes.object,
  renderMode: PropTypes.string
};
